import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { dir: "rtl" }
const _hoisted_2 = { class: "footer-header bg-color3" }
const _hoisted_3 = { class: "container" }
const _hoisted_4 = {
  class: "row py-4",
  "data-aos": "fade-up"
}
const _hoisted_5 = { class: "col-6 px-md-5 text-center h-100" }
const _hoisted_6 = ["src", "alt"]
const _hoisted_7 = { class: "footer-body py-4" }
const _hoisted_8 = { class: "container" }
const _hoisted_9 = { class: "row" }
const _hoisted_10 = { class: "col-12 col-md-4 text-center first-col" }
const _hoisted_11 = {
  class: "logo-container mb-4",
  "data-aos": "fade-up"
}
const _hoisted_12 = ["src", "alt"]
const _hoisted_13 = {
  class: "social-media",
  "data-aos": "fade-left"
}
const _hoisted_14 = ["href"]
const _hoisted_15 = /*#__PURE__*/_createElementVNode("i", { class: "fa-solid fa-phone" }, null, -1)
const _hoisted_16 = [
  _hoisted_15
]
const _hoisted_17 = ["href"]
const _hoisted_18 = /*#__PURE__*/_createElementVNode("i", { class: "fa-brands fa-whatsapp" }, null, -1)
const _hoisted_19 = [
  _hoisted_18
]
const _hoisted_20 = ["href"]
const _hoisted_21 = /*#__PURE__*/_createElementVNode("i", { class: "fa-brands fa-twitter" }, null, -1)
const _hoisted_22 = [
  _hoisted_21
]
const _hoisted_23 = ["href"]
const _hoisted_24 = /*#__PURE__*/_createElementVNode("i", { class: "fa-brands fa-instagram" }, null, -1)
const _hoisted_25 = [
  _hoisted_24
]
const _hoisted_26 = { class: "col-12 col-md-4 text-right second-col mt-5 mt-md-0" }
const _hoisted_27 = { class: "text-white font-weight-bold mb-2" }
const _hoisted_28 = /*#__PURE__*/_createElementVNode("div", { class: "border-bottom border-9 w-15 border-color1 mb-3" }, null, -1)
const _hoisted_29 = { class: "row" }
const _hoisted_30 = {
  class: "col-12 col-md-6",
  "data-aos": "fade-up"
}
const _hoisted_31 = { class: "footer_ul_amrc m-0 font-size-14 p-0 pb-2" }
const _hoisted_32 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-long-arrow-alt-left" }, null, -1)
const _hoisted_33 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-long-arrow-alt-left" }, null, -1)
const _hoisted_34 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-long-arrow-alt-left" }, null, -1)
const _hoisted_35 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-long-arrow-alt-left" }, null, -1)
const _hoisted_36 = {
  class: "col-12 col-md-6",
  "data-aos": "fade-up"
}
const _hoisted_37 = { class: "m-0 font-size-14 p-0 pb-2" }
const _hoisted_38 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-long-arrow-alt-left" }, null, -1)
const _hoisted_39 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-long-arrow-alt-left" }, null, -1)
const _hoisted_40 = { class: "col-12 col-md-4 text-right third-col mt-5 mt-md-0" }
const _hoisted_41 = { class: "text-white font-weight-bold mb-2" }
const _hoisted_42 = /*#__PURE__*/_createElementVNode("div", { class: "border-bottom border-9 w-15 border-color1 mb-3" }, null, -1)
const _hoisted_43 = {
  class: "row",
  "data-aos": "fade-up"
}
const _hoisted_44 = { class: "col-12" }
const _hoisted_45 = { class: "m-0 font-size-14 p-0 pb-2" }
const _hoisted_46 = { key: 0 }
const _hoisted_47 = {
  href: "",
  class: "d-flex"
}
const _hoisted_48 = /*#__PURE__*/_createElementVNode("i", { class: "fa-solid fa-location-dot" }, null, -1)
const _hoisted_49 = ["href"]
const _hoisted_50 = /*#__PURE__*/_createElementVNode("i", { class: "fa-solid fa-phone mx-2" }, null, -1)
const _hoisted_51 = ["href"]
const _hoisted_52 = /*#__PURE__*/_createElementVNode("i", { class: "fa-brands fa-whatsapp" }, null, -1)
const _hoisted_53 = ["href"]
const _hoisted_54 = /*#__PURE__*/_createElementVNode("i", { class: "fa-solid fa-envelope mx-2" }, null, -1)
const _hoisted_55 = { class: "bg-color1" }
const _hoisted_56 = { class: "container" }
const _hoisted_57 = {
  key: 0,
  class: "text-center my-0 py-2"
}

import { ref, reactive, onMounted } from 'vue';
import { useConfigStore, useGlobalStore } from '@/stores';
import { OrganizationType, ContactChannelType } from '@/composables/types';
import logoWhite from '@/assets/logo-white.png';

// stores

export default /*#__PURE__*/_defineComponent({
  __name: 'WebsiteFooter',
  setup(__props) {

const configStore = useConfigStore();
const globalStore = useGlobalStore();

const organization = ref<OrganizationType | undefined>(undefined);

const channels = reactive({
  phone: null as null | ContactChannelType,
  email: null as null | ContactChannelType,
  whatsapp: null as null | ContactChannelType,
  twitter: null as null | ContactChannelType,
  instagram: null as null | ContactChannelType,
});

onMounted(() => {
  if (globalStore.organization.nameAr == null) {
    globalStore.fetchOrganization();
  }
  organization.value = globalStore.organization;

  if (globalStore.contactChannels.length <= 0) {
    globalStore.fetchContactChannels(undefined);
  }
  channels.phone = globalStore.contactChannelByType('phone');
  channels.email = globalStore.contactChannelByType('email');
  channels.whatsapp = globalStore.contactChannelByType('whatsapp');
  channels.twitter = globalStore.contactChannelByType('twitter');
  channels.instagram = globalStore.contactChannelByType('instagram');
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("footer", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("img", {
              src: _unref(logoWhite),
              alt: 
                organization.value
                  ? _unref(configStore).stringLang(
                      organization.value.nameAr,
                      organization.value.nameEn
                    )
                  : ''
              ,
              class: "h-100 mw-100"
            }, null, 8, _hoisted_6)
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_7, [
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("div", _hoisted_11, [
              _createElementVNode("img", {
                src: _unref(logoWhite),
                alt: 
                  organization.value
                    ? _unref(configStore).stringLang(
                        organization.value.nameAr,
                        organization.value.nameEn
                      )
                    : ''
                ,
                class: "mw-75"
              }, null, 8, _hoisted_12)
            ]),
            _createElementVNode("div", _hoisted_13, [
              (channels.phone != null)
                ? (_openBlock(), _createElementBlock("a", {
                    key: 0,
                    href: (channels.phone.link as string),
                    target: "_blank"
                  }, _hoisted_16, 8, _hoisted_14))
                : _createCommentVNode("", true),
              (channels.whatsapp != null)
                ? (_openBlock(), _createElementBlock("a", {
                    key: 1,
                    href: (channels.whatsapp.link as string),
                    target: "_blank"
                  }, _hoisted_19, 8, _hoisted_17))
                : _createCommentVNode("", true),
              (channels.twitter != null)
                ? (_openBlock(), _createElementBlock("a", {
                    key: 2,
                    href: (channels.twitter.link as string),
                    target: "_blank"
                  }, _hoisted_22, 8, _hoisted_20))
                : _createCommentVNode("", true),
              (channels.instagram != null)
                ? (_openBlock(), _createElementBlock("a", {
                    key: 3,
                    href: (channels.instagram.link as string),
                    target: "_blank"
                  }, _hoisted_25, 8, _hoisted_23))
                : _createCommentVNode("", true)
            ])
          ]),
          _createElementVNode("div", _hoisted_26, [
            _createElementVNode("h5", _hoisted_27, _toDisplayString(_ctx.$t('INTERESTING_LINKS')), 1),
            _hoisted_28,
            _createElementVNode("div", _hoisted_29, [
              _createElementVNode("div", _hoisted_30, [
                _createElementVNode("ul", _hoisted_31, [
                  _createElementVNode("li", null, [
                    _createElementVNode("a", {
                      onClick: _cache[0] || (_cache[0] = 
                        () => {
                          _ctx.$router.push({ name: 'aboutPage' });
                        }
                      )
                    }, [
                      _hoisted_32,
                      _createElementVNode("span", null, _toDisplayString(_ctx.$t('ABOUT_ORGANIZATION')), 1)
                    ])
                  ]),
                  _createElementVNode("li", null, [
                    _createElementVNode("a", {
                      onClick: _cache[1] || (_cache[1] = 
                        () => {
                          _ctx.$router.push({
                            name: 'postsList',
                            params: { type: 'products' },
                          });
                        }
                      )
                    }, [
                      _hoisted_33,
                      _createElementVNode("span", null, _toDisplayString(_ctx.$t('OUR_PRODUCTS')), 1)
                    ])
                  ]),
                  _createElementVNode("li", null, [
                    _createElementVNode("a", {
                      onClick: _cache[2] || (_cache[2] = 
                        () => {
                          _ctx.$router.push({ name: 'projectsPage' });
                        }
                      )
                    }, [
                      _hoisted_34,
                      _createElementVNode("span", null, _toDisplayString(_ctx.$t('OUR_PROJECTS')), 1)
                    ])
                  ]),
                  _createElementVNode("li", null, [
                    _createElementVNode("a", {
                      onClick: _cache[3] || (_cache[3] = 
                        () => {
                          _ctx.$router.push({ name: 'partnersPage' });
                        }
                      )
                    }, [
                      _hoisted_35,
                      _createElementVNode("span", null, _toDisplayString(_ctx.$t('OUR_PARTNERS')), 1)
                    ])
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_36, [
                _createElementVNode("ul", _hoisted_37, [
                  _createElementVNode("li", null, [
                    _createElementVNode("a", {
                      onClick: _cache[4] || (_cache[4] = 
                        () => {
                          _ctx.$router.push({ name: 'contactUsPage' });
                        }
                      )
                    }, [
                      _hoisted_38,
                      _createElementVNode("span", null, _toDisplayString(_ctx.$t('CONTACT_US')), 1)
                    ])
                  ]),
                  _createElementVNode("li", null, [
                    _createElementVNode("a", {
                      onClick: _cache[5] || (_cache[5] = 
                        () => {
                          _ctx.$router.push({ name: 'homePage' });
                        }
                      )
                    }, [
                      _hoisted_39,
                      _createElementVNode("span", null, _toDisplayString(_ctx.$t('WEBSITE_ROAD_MAP')), 1)
                    ])
                  ])
                ])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_40, [
            _createElementVNode("h5", _hoisted_41, _toDisplayString(_ctx.$t('HAPPY_FOR_YOUR_CONTACT')), 1),
            _hoisted_42,
            _createElementVNode("div", _hoisted_43, [
              _createElementVNode("div", _hoisted_44, [
                _createElementVNode("ul", _hoisted_45, [
                  (organization.value)
                    ? (_openBlock(), _createElementBlock("li", _hoisted_46, [
                        _createElementVNode("a", _hoisted_47, [
                          _hoisted_48,
                          _createElementVNode("span", null, _toDisplayString(_unref(configStore).stringLang(
                          organization.value.addressAr,
                          organization.value.addressEn
                        )), 1)
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  _createElementVNode("li", null, [
                    (channels.phone != null)
                      ? (_openBlock(), _createElementBlock("a", {
                          key: 0,
                          href: (channels.phone.link as string),
                          target: "_blank"
                        }, [
                          _hoisted_50,
                          _createElementVNode("span", null, _toDisplayString(channels.phone.value), 1)
                        ], 8, _hoisted_49))
                      : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("li", null, [
                    (channels.whatsapp != null)
                      ? (_openBlock(), _createElementBlock("a", {
                          key: 0,
                          href: (channels.whatsapp.link as string),
                          target: "_blank"
                        }, [
                          _hoisted_52,
                          _createElementVNode("span", null, _toDisplayString(channels.whatsapp.value), 1)
                        ], 8, _hoisted_51))
                      : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("li", null, [
                    (channels.email != null)
                      ? (_openBlock(), _createElementBlock("a", {
                          key: 0,
                          href: (channels.email.link as string),
                          target: "_blank"
                        }, [
                          _hoisted_54,
                          _createElementVNode("span", null, _toDisplayString(channels.email.value), 1)
                        ], 8, _hoisted_53))
                      : _createCommentVNode("", true)
                  ])
                ])
              ])
            ])
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_55, [
      _createElementVNode("div", _hoisted_56, [
        (organization.value)
          ? (_openBlock(), _createElementBlock("p", _hoisted_57, _toDisplayString('© ' +
            new Date().getFullYear() +
            ' ' +
            _ctx.$t('COPYRIGHT') +
            _unref(configStore).stringLang(organization.value.nameAr, organization.value.nameEn)), 1))
          : _createCommentVNode("", true)
      ])
    ])
  ]))
}
}

})